module.exports = __webpack_public_path__ + "img/maisprocurado.52ae23e7.svg";